import React from 'react';
import useProfileConnectedHealthSystems from '../../../../../hooks/api/useProfileConnectedHealthSystems';
import Stack from '../../../../v2BaseComponents/Stack';
import { useHasPermission } from '../../../../v2BaseComponents/Permissions/hooks';
import { Switch } from '../../../../v2BaseComponents/Inputs';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('portal-connection-details-disable-automatic-refresh-toggle', {
    automaticRefreshEnabled: 'Automatically refresh this portal',
});

export type DisableAutomaticRefreshToggleOwnProps = {
    healthSystemId: string;
    medicalProfileId: string;
    isEligibleForAutomaticRefresh: boolean;
};

export type DisableAutomaticRefreshToggleProps = DisableAutomaticRefreshToggleOwnProps;

const DisableAutomaticRefreshToggle: React.FC<DisableAutomaticRefreshToggleProps> = (props) => {
    const {
        isLoadingHealthSystemConnectionDetails,
        isLoading,
        isUpdatingAutomaticRefresh,
        updateAutomaticRefresh,
        healthSystemConnectionDetails,
    } = useProfileConnectedHealthSystems({
        medicalProfileId: props.medicalProfileId,
        healthSystemId: props.healthSystemId,
    });
    const hasPortalEditPermissions = useHasPermission(props.medicalProfileId, 'patientPortals', 'edit');

    if (
        isLoading ||
        isLoadingHealthSystemConnectionDetails ||
        !hasPortalEditPermissions ||
        !props.isEligibleForAutomaticRefresh
    )
        return null;

    return (
        <Stack fullWidth horizontal justify="center">
            <Switch
                isDisabled={isUpdatingAutomaticRefresh}
                value={!healthSystemConnectionDetails?.userDisabledAutomaticRefresh}
                onChange={(value) => updateAutomaticRefresh(!value)}
                title={intl('automaticRefreshEnabled')}
            />
        </Stack>
    );
};

export default React.memo(DisableAutomaticRefreshToggle);
